/* eslint-disable react/require-default-props */
import Flex from '@deprecated-ui/common/Flex';
import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { ButtonContainer, Modal, ButtonConfirm, ButtonCancel } from './styled';
import { selectors } from './slice';

interface ConfirmationModalProps {
  children: ReactNode;
  isVisible: boolean;
  title: string;
  isBlock?: boolean;
  confirmText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

function ConfirmationModal({
  children,
  isVisible,
  title,
  isBlock = false,
  confirmText = 'Confirm',
  onConfirm,
  onCancel,
}: ConfirmationModalProps) {
  const { isCollectionLoading } = useSelector(selectors);

  const containerPadding = !isBlock && '20px 16px';

  return (
    <Modal
      visible={isVisible}
      title={title}
      onCancel={onCancel}
      width="520px"
      centered
    >
      <Flex direction="column" padding={containerPadding}>
        {children}
        <ButtonContainer
          align="center"
          justify="flex-end"
          // @ts-expect-error
          mt="8px"
          width="100%"
          block={isBlock}
        >
          <ButtonCancel
            onClick={onCancel}
            loading={isCollectionLoading}
            block={isBlock}
          >
            Cancel
          </ButtonCancel>
          <ButtonConfirm
            onClick={onConfirm}
            loading={isCollectionLoading}
            block={isBlock}
          >
            {confirmText}
          </ButtonConfirm>
        </ButtonContainer>
      </Flex>
    </Modal>
  );
}

export default ConfirmationModal;
